import ucfirst from '@/packages/string/ucfirst';
import cn from 'classnames';
import { SelectGroupProps } from './interfaces';
import styles from './styles/selectGroup.module.scss';

export function SelectGroup(props: SelectGroupProps): React.JSX.Element {
    const theme = props.theme ? `theme${ucfirst(props.theme)}` : '';

    const selectClassNames = cn(props.className, styles.selectGroup, styles[theme]);

    return <div className={selectClassNames}>{props.children}</div>;
}
